import React, {Component} from 'react';
import './repair.css';
import ReactHtmlParser from "react-html-parser";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from 'react-responsive-carousel';
import {IMAGE_URL} from "../constants";

class Repair extends Component {
    state = {
        pageData: this.props.pageData,
        images: []
    };
    componentWillMount() {
        let imageList = [];
        if(this.state.pageData.image1.length > 0){
            imageList.push({url: this.state.pageData.image1});
        }
        if(this.state.pageData.image2.length > 0){
            imageList.push({url: this.state.pageData.image2});
        }
        if(this.state.pageData.image3.length > 0){
            imageList.push({url: this.state.pageData.image3});
        }
        this.setState({images: imageList});
    }
    render() {
        return <div className="repair">
            <div className="repairMain">
                <div className="repairMainLeft">
                    <div className="repairContent">
                    {this.props.lang === "tr" && <div className="repairTitle">
                        {ReactHtmlParser(this.state.pageData.title_tr)}
                    </div>}
                    {this.props.lang === "eng" && <div className="repairTitle">
                        {ReactHtmlParser(this.state.pageData.title_eng)}
                    </div>}
                    {this.props.lang === "tr" && <div className="repairText">
                        {ReactHtmlParser(this.state.pageData.content_tr)}
                        <div className="repairIndicator"></div>
                    </div>}
                    {this.props.lang === "eng" && <div className="repairText">
                        {ReactHtmlParser(this.state.pageData.content_eng)}
                        <div className="repairIndicator"></div>
                    </div>}
                    </div>
                </div>
                <div className="repairMainRight">
                    <div className="repairSliderContainer">
                        <div className="repairSlider">
                            <Carousel className="slider" showThumbs={false} showStatus={false} autoPlay interval={5000} transitionTime={1000} infiniteLoop axis="horizontal">
                                {this.state.images.length > 0 &&
                                this.state.images.map((item, index) => {
                                    let url = IMAGE_URL + item.url;
                                    return (<div key={index}><img alt="" src={url}/></div>);
                                })
                                }
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    }
}
/*{ReactHtmlParser(this.state.content)}*/
export default Repair;